<template>
  <div>
    <article class="con2">
      <ul class="container">
        <li class="main-list-wrapper" v-for="(item, i) in recruitList" :key="i">
          <p class="main-title">{{ item.title }}</p>
          <ul class="position-wrapper">
            <li v-for="(position, j) in item.positions" :key="j">
              <p class="work-list-title">{{ position.title }}</p>
              <div class="work-list-wrapper">
                <p v-for="(task, k) in position.tasks" :key="k">
                  {{ task }}
                </p>
              </div>
              <p
                class="go-support"
                @click="showSupportPopup(item.title, position.title)"
              >
                지원하기
              </p>
            </li>
          </ul>
        </li>
      </ul>
    </article>

    <!-- 지원하기 팝업 -->
    <SupportPopup
      v-if="isSupportPopupVisible"
      @closeSupportPopup="hideSupportPopup"
      :selectedSector2="selectedSector2"
      :selectedDuty2="selectedDuty2"
    ></SupportPopup>
  </div>
</template>

<script>
import "@/assets/style/newGlobalReset.scss";
import SupportPopup from "./SupportPopup.vue";

export default {
  components: { SupportPopup },
  data() {
    return {
      // 선택한 지원분야 값 초기화
      selectedSector2: "",
      selectedDuty2: "",

      // 지원분야
      recruitList: [
        {
          title: "교육 컨설팅 부문",
          positions: [
            {
              title: "기업교육 컨설턴트",
              tasks: [
                "· 고객사 교육 운영 및 모니터링(학습자, 강사 관리)",
                "· 교육과정 운영 보고서 작성 및 관련 서류 관리",
                "· 교육담당자(HRDer), 학습자, 강사 커뮤니케이션",
                "· 기업 맞춤형 교육 컨설팅 및 과정 제안",
              ],
            },
            {
              title: "HR 컨설턴트",
              tasks: [
                "· HR전략/역량모델링/조직문화 등 HR 관련 컨설팅",
                "· 조직 진단 사업 기획/운영/관리",
                "· 리더십 진단 관련 개발 및 운영",
              ],
            },
            {
              title: "전화 / 화상 학습 매니저 (B2B)",
              tasks: [
                "· 전화/화상 외국어 학습 설계 및 안내",
                "· 교육 과정 성과 및 운영 보고서 작성",
                "· 기업고객 응대 및 만족도 관리",
                "· 기업 맞춤형 교육 컨설팅 및 과정 제안",
              ],
            },
            {
              title: "B2C 고객 학습 매니저",
              tasks: [
                "· 전화/화상 외국어과정 개인 고객 과정운영",
                "· 개인 고객 학습 설계 및 안내",
                "· 개인 고객 학습 일정 관리 및 수업 상담",
              ],
            },
            {
              title: "교수운영 매니저 (THR)",
              tasks: [
                "· 원어민 강사 채용 (온라인/오프라인 별도)",
                "· 강사교육 및 Quality Control",
                "· 강사 요청 사항 처리 및 상담",
                "· 강사 관련 행사 주최",
                "· 해외센터 강사 관리 및 운영",
              ],
            },
          ],
        },
        {
          title: "교육 콘텐츠 기획 / 개발 부문",
          positions: [
            {
              title: "언어교육콘텐츠 연구원",
              tasks: [
                "· 맞춤형 어학 교재 개발",
                "· 개발 교재 및 콘텐츠 검수",
                "· 연구소 프로젝트 기획 및 관리(PM)",
                "· Teaching Guide 제작",
              ],
            },
            {
              title: "교육콘텐츠 PM",
              tasks: [
                "· 기업 어학 및 직무 교육 교재 기획/개발",
                "· 웹/앱/이러닝 콘텐츠 기획 및 개발",
                "· 교육 콘텐츠 분석 및 Quality Control",
                "· 어학평가 리뷰 및 분석",
              ],
            },
            {
              title: "이러닝 사업기획",
              tasks: [
                "· 이러닝 서비스 사업 메이킹",
                "· 기존 이러닝 콘텐츠 상품화 및 사업화",
                "· 에듀테크 서비스 기획 및 런칭",
              ],
            },
            {
              title: "영상제작 PD",
              tasks: [
                "· 홍보물, 이러닝 강의 등 영상 콘텐츠 제작",
                "· 다양한 형식의 학습 영상 콘텐츠 제작 (크로마합성, 인포그래픽스, 모션그래픽 등)",
                "· 영상 디자인/기획/편집 등 PD 역할 전반",
                "· 영상 컨텐츠 기획/제작 전반",
              ],
            },
          ],
        },
        {
          title: "IT 개발 / 기획 부문",
          positions: [
            {
              title: "웹 개발자",
              tasks: [
                "· 교육 서비스 개발(웹/어플리케이션)",
                "· API 개발 및 유지보수",
                "· 개발언어 : php / Mysql / java / javascript(vue framework)",
              ],
            },
            {
              title: "웹 기획자",
              tasks: [
                "· 교육 서비스 신규 구축 및 운영",
                "· 데이터 분석 및 서비스 개선 기획",
                "· 사용자 경험(UX) 기반 웹/앱 서비스 기획",
                "· 서비스 기획에 따른 유관부서와의 일정 및 이슈 협의",
              ],
            },
            {
              title: "웹 디자이너",
              tasks: [
                "· 웹/App 컨텐츠 및 프로모션 디자인",
                "· 교육 서비스 디자인",
                "· 신규 웹/App UX컨설팅 및 UI디자인",
                "· html/css 퍼블리싱",
              ],
            },
          ],
        },
        {
          title: "마케팅 부문",
          positions: [
            {
              title: "디지털 마케터",
              tasks: [
                "· 캐럿글로벌 '당근영어' 브랜드 마케팅 총괄",
                "· 전사 온라인/오프라인 마케팅 총괄 기획",
              ],
            },
          ],
        },
        {
          title: "Staff 부문",
          positions: [
            {
              title: "HR 매니저",
              tasks: [
                "· 채용 관리",
                "· 사내 교육 기획 및 운영",
                "· 조직문화 기획 및 계발",
                "· 노무 및 기타 인사 관리 전반 담당",
              ],
            },
            {
              title: "총무 매니저",
              tasks: [
                "· 시설 및 차량 등 사내 관리 총괄",
                "· 사내 행사 기획 및 의전활동 수행",
                "· 비품 구매 및 관리",
              ],
            },
            {
              title: "회계 매니저",
              tasks: [
                "· 손익관리 분석 및 경영계획 수립",
                "· 효율적인 세무 운영",
                "· 자금 차입 및 운용, 유동성 관리",
              ],
            },
          ],
        },
        {
          title: "기타",
          positions: [
            {
              title: "캐럿글로벌 '인재 Pool'",
            },
          ],
        },
      ],

      // 팝업 초기화
      isSupportPopupVisible: false,
    };
  },
  methods: {
    // 팝업 열기, 선택한 지원분야 값 전달
    showSupportPopup(item, position) {
      this.selectedSector2 = item;
      this.selectedDuty2 = position;

      this.isSupportPopupVisible = true;
    },

    // 팝업 닫기
    hideSupportPopup() {
      this.isSupportPopupVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.con2 {
  padding: 40px 0;
  background-color: #f7f7f7;

  @media screen and (min-width: 1350px) {
    padding: 80px 0;
  }

  .main-list-wrapper {
    &:not(:last-child) {
      margin-bottom: 40px;

      @media screen and (min-width: 1350px) {
        margin-bottom: 80px;
      }
    }

    .main-title {
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 10px;

      @media screen and (min-width: 1350px) {
        font-size: 40px;
      }
    }

    .position-wrapper {
      border-top: 2px solid #000000;
      border-bottom: 2px solid #000000;

      > li {
        display: grid;
        grid-template-columns: 1fr 2fr 1fr;
        align-items: center;
        gap: 20px;
        padding: 30px;

        &:not(:last-child) {
          border-bottom: 1px solid #dddddd;
        }

        .work-list-title,
        .go-support {
          text-align: center;
        }

        .work-list-title {
          font-size: 20px;
          font-weight: 700;
        }

        .go-support {
          font-size: 18px;
          text-decoration: underline;
          cursor: pointer;
        }

        .work-list-wrapper {
          display: flex;
          flex-direction: column;
          gap: 10px;

          p {
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>
